import { Button, Grid } from '@mui/material';
import Container from './Container';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router';

const ContainerWithGoBack = (props) => {
    const history = useNavigate();
    return (
        <Container>
            <Grid container spacing={3}>
                <Grid size={12}>
                    <Button
                        onClick={() => history(-1)}
                        variant="contained"
                        color="secondary"
                    >
                        <ArrowBackIcon style={{ marginRight: '10px' }} />
                        Voltar
                    </Button>
                </Grid>
                <Grid size={12}>
                    {props.children}
                </Grid>
            </Grid>
        </Container >
    );
}

export default ContainerWithGoBack;